import { InventoryEventOption } from '../types';

const DAY_IN_MS = 24 * 60 * 60 * 1000;

/** 梯次尚未開始、但在這個天數內就要開跑時，視為「行前備料」而優先選取。 */
export const UPCOMING_EVENT_WINDOW_DAYS = 7;

const startOfToday = (now: Date) => {
  const today = new Date(now.getTime());
  today.setHours(0, 0, 0, 0);
  return today.getTime();
};

const byStartTimeAsc = (a: InventoryEventOption, b: InventoryEventOption) =>
  (a.startTime || 0) - (b.startTime || 0);

/**
 * 挑出物資管理進場時要預設顯示的梯次。
 *
 * 現場清點的人多半不會自己去切梯次下拉，所以預設值必須落在他們當下真正在
 * 盤點的那一梯，優先序為：
 *
 *   1. 進行中（今天落在起訖日之間）——現場清點
 *   2. UPCOMING_EVENT_WINDOW_DAYS 天內即將開始 ——行前備料
 *   3. 最近結束的 ——事後補登
 *   4. 最早開始的 ——年度尚未有任何梯次跑過時的保底
 */
export const chooseDefaultInventoryEventId = (
  options: InventoryEventOption[],
  now: Date = new Date()
): string => {
  if (options.length === 0) return '';

  const todayTime = startOfToday(now);

  const ongoing = options
    .filter(option =>
      option.startTime !== null &&
      option.endTime !== null &&
      option.startTime <= todayTime &&
      option.endTime >= todayTime
    )
    .sort(byStartTimeAsc);

  if (ongoing[0]) return ongoing[0].id;

  const upcomingLimit = todayTime + UPCOMING_EVENT_WINDOW_DAYS * DAY_IN_MS;
  const upcoming = options
    .filter(option =>
      option.startTime !== null &&
      option.startTime > todayTime &&
      option.startTime <= upcomingLimit
    )
    .sort(byStartTimeAsc);

  if (upcoming[0]) return upcoming[0].id;

  const completed = options
    .filter(option => option.endTime !== null && option.endTime < todayTime)
    .sort((a, b) => (b.endTime || 0) - (a.endTime || 0));

  if (completed[0]) return completed[0].id;

  const dated = options.filter(option => option.startTime !== null).sort(byStartTimeAsc);

  return dated[0]?.id || options[0].id;
};
